import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Field, reduxForm } from 'redux-form';
import './main.less';

import ModalBox from '../../../shared/modal';
import Input from '../../../shared/form-elements/input';

const Form = props => {
	const submit = data => props.submitWhitelistedIp(data);

	return (
		<div className='approve-daily-form display-flex-column'>
			<div className="approve-daily-container">
				{
					props.whitelistedIps.map((item, index) =>
						<div className="display-flex row" key={index}>
							<div className="cell width-200">{item}</div>
							<div className="cell">
								<span className="delete" onClick={props.removeWhitelistedIp.bind(null, item)}/>
							</div>
						</div>
					)
				}
			</div>
			<form className='ui-form payouts-form__main clearfix' onSubmit={props.handleSubmit(submit)}>
				<div className="ui-form__element width-200">
					<Field
						name="value"
						placeholder={props.intl('Ip')}
						component={Input}
						showLabel={false}
					/>
				</div>
				<button
					className={cn({
						'ui-btn': true,
						'ui-btn-primary apply': true
					})}
					type='submit'
				>{props.intl('Apply')}</button>
				<button
					className='ui-btn ui-btn-cancel cancel'
					onClick={e => {
						e.preventDefault();
						props.toggleWhitelistedIpsForm();
					}}
				>{props.intl('Cancel')}</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Whitelisted ips')}
		body={Form(props)}
		isOpen={props.isDailyApprovePopupShowed}
		onClose={props.toggleWhitelistedIpsForm}
		className='form-modal approve-daily-modal'
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({ form: 'whitelistedIpsForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/whitelisted-ips-form/main.js